import { AddressType, type JsonDataItem } from 'types';
import { externalQuery } from '../externalQuery';

import env from 'env';

export const getAddressPrediction = async ({ value, type }: JsonDataItem) => {
  const addressType = type === AddressType.Postal ? 'all' : type;

  const data = await externalQuery(
    `https://api.psma.com.au/v1/predictive/address?addressType=${addressType}&query=${value}`,
    {
      headers: {
        Authorization: env.GEOSCAPE_API_KEY,
      },
    },
  );

  return data;
};
